import styled from "styled-components/macro";

import {
  BREAKPOINT_DESKTOP,
  BREAKPOINT_TABLET,
} from "../../../../constants/constants";
import { IGNORE_BREAKPOINT_MIN_WIDTH } from "./HubletViewStyles";
import { animated } from "@react-spring/web";
function percentWidth(width: number | undefined, percent: number) {
  return `${((width || 0) * percent) / 100}px`;
}
const StatusIndicatorStyles = styled.div<{
  $width?: number;
  $isGridLayout?: boolean;
}>`
  width: 100%;
  text-align: center;
  .process-state-elapsed {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: ${props => percentWidth(props.$width, -0.4)};
    padding-left: ${props => percentWidth(props.$width, 4)};
  }
  .process-state-elapsed-quantity {
    font-size: ${props => percentWidth(props.$width, 23)};
    &.small {
      font-size: ${props => percentWidth(props.$width, 13.8)};
    }
  }
  .process-state-elapsed-units {
    font-size: ${props => percentWidth(props.$width, 10.5)};
  }
  .status-indicator-tag-name {
    font-size: ${props => percentWidth(props.$width, 5)};
  }
  .status-indicator-machine-name {
    opacity: 0.7;
    font-size: ${props =>
      percentWidth(props.$width, props.$isGridLayout ? 6 : 3.8)};
  }
  .status-indicator-status {
    font-size: ${props => percentWidth(props.$width, 1.5)};
  }

  @media (min-width: ${props =>
      props.$isGridLayout
        ? IGNORE_BREAKPOINT_MIN_WIDTH // for custom layout, ignore this breakpoint
        : BREAKPOINT_TABLET}px) and (max-width: ${BREAKPOINT_DESKTOP}px) {
    .process-state-elapsed {
      margin-bottom: -3.2px;
      padding-left: 31.8px;
    }
    .process-state-elapsed-quantity {
      font-size: 183px;
      &.small {
        font-size: 110px;
      }
    }
    .process-state-elapsed-units {
      font-size: 83px;
    }
    .status-indicator-tag-name {
      font-size: 40px;
    }
    .status-indicator-machine-name {
      font-size: 30px;
    }
    .status-indicator-status {
      font-size: 12px;
    }
  }

  @media print {
    .process-state-elapsed-quantity {
      font-size: 60px;
      &.small {
        font-size: 36px;
      }
    }
    .process-state-elapsed-units {
      font-size: 16px;
    }
    .status-indicator-tag-name {
      font-size: 20px;
    }
    .status-indicator-machine-name {
      font-size: 20px;
    }
    .status-indicator-status {
      font-size: 12px;
    }
  }
`;
export const AnimatedStatusIndicatorStyles = animated(StatusIndicatorStyles);
